import { Request } from "@/data/Requests";
import { OFF_DUTY_PATIENT_ID } from "@/utils/constants";

export const formatAppointmentPurpose = (appointment: Request): string => {
  const isOffDuty = appointment.patient_id === OFF_DUTY_PATIENT_ID;
  let displayPurpose = isOffDuty ? "Off-duty" : appointment.purpose;

  if (displayPurpose && displayPurpose.startsWith("Others: ")) {
    displayPurpose = displayPurpose.replace("Others: ", "");
  }

  return displayPurpose || "Appointment";
};
